import getName from '../../../../../helpers/getName';

export const getTooltipTitleForWorker = (worker) =>
  [
    getName(worker),
    Boolean(worker?.specialityName) && `(${worker.specialityName.trim()})`,
  ]
    .filter(Boolean)
    .join(' ');
